/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingProductPriceTiersInner } from './BillingProductPriceTiersInner';
import {
    BillingProductPriceTiersInnerFromJSON,
    BillingProductPriceTiersInnerFromJSONTyped,
    BillingProductPriceTiersInnerToJSON,
    BillingProductPriceTiersInnerToJSONTyped,
} from './BillingProductPriceTiersInner';
import type { BillingProduct } from './BillingProduct';
import {
    BillingProductFromJSON,
    BillingProductFromJSONTyped,
    BillingProductToJSON,
    BillingProductToJSONTyped,
} from './BillingProduct';

/**
 * 
 * @export
 * @interface BillingProductPrice1
 */
export interface BillingProductPrice1 {
    /**
     * 
     * @type {number}
     * @memberof BillingProductPrice1
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingProductPrice1
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingProductPrice1
     */
    interval: BillingProductPrice1IntervalEnum | null;
    /**
     * 
     * @type {number}
     * @memberof BillingProductPrice1
     */
    fixedPrice: number | null;
    /**
     * 
     * @type {Array<BillingProductPriceTiersInner>}
     * @memberof BillingProductPrice1
     */
    tiers: Array<BillingProductPriceTiersInner> | null;
    /**
     * 
     * @type {BillingProduct}
     * @memberof BillingProductPrice1
     */
    billingProduct?: BillingProduct;
}

/**
* @export
* @enum {string}
*/
export enum BillingProductPrice1IntervalEnum {
    Annual = 'Annual',
    Monthly = 'Monthly'
}


/**
 * Check if a given object implements the BillingProductPrice1 interface.
 */
export function instanceOfBillingProductPrice1(value: object): value is BillingProductPrice1 {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('fixedPrice' in value) || value['fixedPrice'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function BillingProductPrice1FromJSON(json: any): BillingProductPrice1 {
    return BillingProductPrice1FromJSONTyped(json, false);
}

export function BillingProductPrice1FromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingProductPrice1 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'interval': json['interval'],
        'fixedPrice': json['fixedPrice'],
        'tiers': (json['tiers'] == null ? null : (json['tiers'] as Array<any>).map(BillingProductPriceTiersInnerFromJSON)),
        'billingProduct': json['billingProduct'] == null ? undefined : BillingProductFromJSON(json['billingProduct']),
    };
}

  export function BillingProductPrice1ToJSON(json: any): BillingProductPrice1 {
      return BillingProductPrice1ToJSONTyped(json, false);
  }

  export function BillingProductPrice1ToJSONTyped(value?: BillingProductPrice1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'interval': value['interval'],
        'fixedPrice': value['fixedPrice'],
        'tiers': (value['tiers'] == null ? null : (value['tiers'] as Array<any>).map(BillingProductPriceTiersInnerToJSON)),
        'billingProduct': BillingProductToJSON(value['billingProduct']),
    };
}

